import { TitleButton } from '@/common/buttons/TitleButton';
import { ActionDialog } from '@/common/dialog/ActionDialog';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { DemForecastChannelPerspective } from '../forecastChannel/DemForecastChannelPerspective';
import { DemForecastProdPerspective } from '../forecastProd/DemForecastProdPerspective';
import { DemForecastGtnTab } from './DemForecastGtnTab';

export const DemForecastDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'gtnTab', label: 'Gross-to-Net', content: <DemForecastGtnTab forecastId={entityObj.id} /> },
    { id: 'prodTab', label: 'Products', content: <DemForecastProdPerspective forecastId={entityObj.id} /> },
    { id: 'channelTab', label: 'Channels', content: <DemForecastChannelPerspective forecastId={entityObj.id} /> },
  ];

  const augButtons = (buttons) => {
    buttons.push(
      <TitleButton
        toolTip={'Publish Accrual Rates'}
        icon={fas.faStamp}
        onClick={() => openActionDialog('Publish Accrual Rates', 'ACCR_RATE_PUBLISH_ACTION_PLUGIN')}
      />,
    );
  };

  const { openDialog } = useDialog();
  const openActionDialog = (title, pluginCode) => {
    openDialog(ActionDialog, {
      data: {
        title,
        pluginCode,
        entity: 'FORECAST',
        entityId: entityObj.id,
      },
    });
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
